module.exports = __webpack_public_path__ + "static/img/wechatPic.cf4cc16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechatPic.jpg
// module id = 8wHZ
// module chunks = 45